<template>
  <div class="wrapper" id="app">
    <header-tmp v-if="!isLogin" />
    <sidebar-tmp v-if="!isLogin" />
    <popup-tmp />
    <popup-preview-tmp />
    <spinner v-if="isLoadingSpinner" class="spinner" line-fg-color="#00d3ca" line-bg-color="#ffffff" />
    <router-view />
    <footer-tmp v-if="!isLogin" />
    <google-map />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import HeaderTmp from '@/components/common/header.vue';
import FooterTmp from '@/components/common/footer.vue';
import SidebarTmp from '@/components/common/sidebar.vue';
import PopupTmp from '@/components/common/popup.vue';
import PopupPreviewTmp from '@/components/common/previewPopups.vue';
import Spinner from 'vue-simple-spinner';
import '@/styles/main.scss';
import GoogleMap from '@/components/common/googleMap.vue';
import store from '@/store';
import type { StoreState } from '@/store.types';

export default Vue.extend({
  name: 'app',
  components: {
    HeaderTmp,
    FooterTmp,
    SidebarTmp,
    PopupTmp,
    PopupPreviewTmp,
    Spinner,
    GoogleMap
  },
  computed: {
    isLogin(): boolean {
      return this.$route.name === 'login';
    },
    isLoadingSpinner(): boolean {
      return (store as unknown as { state: StoreState }).state.isLoadingSpinner;
    }
  },
});

</script>
